<template>
  <v-content>
    <v-container fluid fill-height>
      <v-layout align-center justify-center>
        <p class="headline">Page not found</p>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
export default {
  
}
</script>



// WEBPACK FOOTER //
// src/components/Misc/404.vue